"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9092],{

/***/ 29242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ StyledPage; },
/* harmony export */   "R": function() { return /* binding */ PageContentContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        background-color: ",
        ";\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  position: relative;\n\n  > header {\n    margin-top: auto;\n  }\n\n  main {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    flex-grow: 1;\n    z-index: 1;\n    background-color: ",
        ";\n\n    ",
        "\n\n    &.has-bottombar {\n      @media (max-width: ",
        ") {\n        > :nth-last-child(2) > *:first-child {\n          padding-bottom: 4rem;\n        }\n      }\n    }\n\n    #pageTop {\n      display: flex;\n      flex-direction: column;\n      flex-grow: 1;\n    }\n  }\n\n  > footer {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var roleVariants = {
    offer: {
        backgroundColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("sand_100")
    },
    offersList: {
        backgroundColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white")
    },
    dark: {
        backgroundColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_900")
    },
    stackOverflow: {
        backgroundColor: "#111C27"
    },
    resistance: {
        backgroundColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("#111C27")
    },
    landing: {
        backgroundColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white")
    },
    classicProfile: {
        backgroundColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white")
    },
    light: {
        backgroundColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white")
    },
    midnight_light: {
        backgroundColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_100")
    },
    your_salary_offer: {
        backgroundColor: "#FBEDFF"
    }
};
var PageContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b2d71673-0"
})(_templateObject(), function(param) {
    var containerSize = param.containerSize;
    return (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .container */ .nC)(containerSize);
});
var StyledPage = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b2d71673-1"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("sand_100"), function(param) {
    var variant = param.variant;
    return variant && roleVariants[variant] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), roleVariants[variant].backgroundColor);
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lgMax"));


/***/ }),

/***/ 9092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ layout_Page; }
});

// UNUSED EXPORTS: Footer, PageNav, ScrollTop

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/Button.styled.tsx
var Button_styled = __webpack_require__(59760);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/landing/LandingNotification.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.1;\n  text-align: center;\n  min-height: 3.5rem;\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  max-width: 87.5rem;\n  margin: 0 auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  width: 100%;\n\n  a {\n    color: ",
        ";\n    font-weight: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n  padding-right: ",
        ";\n\n  button:hover {\n    background-color: transparent;\n  }\n\n  svg {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


// styled-components.
// -----------------------------------------------------------------------------
var LandingNotificationRoot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-251cb4cd-0"
})(_templateObject(), (0,theme/* color */.$_)("notice_200"), (0,theme/* color */.$_)("notice_900"), (0,theme/* fontSize */.JB)("sm"));
var LandingNotificationWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-251cb4cd-1"
})(_templateObject1(), (0,theme/* spacing */.W0)("xs"));
var LandingNotificationText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-251cb4cd-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* color */.$_)("notice_900"), (0,theme/* fontWeight */.Ue)("extraBold"));
var LandingNotificationClose = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-251cb4cd-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("notice_900"));

;// CONCATENATED MODULE: ./components/marketingSite/landing/LandingNotification.tsx





// Componente.
// -----------------------------------------------------------------------------
var LandingNotification = function(param) {
    var children = param.children, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingNotificationRoot, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LandingNotificationWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingNotificationText, {
                    children: children
                }),
                !!onClose && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingNotificationClose, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_styled/* default */.Z, {
                        isIcon: true,
                        onClick: onClose,
                        sizes: "sm",
                        variant: "tertiary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons/* faXmark */.g82
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var landing_LandingNotification = (LandingNotification);

// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ../../node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(63201);
// EXTERNAL MODULE: ../../node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(81192);
// EXTERNAL MODULE: ./components/layout/Page.styled.tsx
var Page_styled = __webpack_require__(29242);
// EXTERNAL MODULE: ./components/layout/PageDrawerContext.tsx
var PageDrawerContext = __webpack_require__(55615);
// EXTERNAL MODULE: ../../node_modules/@auth0/nextjs-auth0/dist/client/index.js
var client = __webpack_require__(5778);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react-headroom/dist/index.js
var dist = __webpack_require__(87482);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/logos.ts
var logos = __webpack_require__(4335);
;// CONCATENATED MODULE: ./components/layout/topbar/TopbarNav.styled.tsx

function TopbarNav_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  line-height: 1;\n  vertical-align: text-bottom;\n  color: ",
        ";\n\n  @media (max-width: ",
        ") {\n    display: inline-flex;\n    align-items: center;\n\n    &::before {\n      content: '';\n      width: ",
        ";\n      height: 1px;\n      background-color: ",
        ";\n      margin-right: ",
        ";\n    }\n  }\n\n  &.active {\n    color: ",
        ";\n\n    &::before {\n      background-color: ",
        ";\n      height: 2px;\n    }\n  }\n\n  .mobileSubnavTrigger & {\n    background-color: unset;\n    border: 0;\n    padding: 0;\n    width: 100%;\n    font-size: inherit;\n  }\n"
    ]);
    TopbarNav_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TopbarNav_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  color: ",
        ";\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n  }\n"
    ]);
    TopbarNav_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TopbarNav_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  position: absolute;\n  top: ",
        ";\n  left: 0;\n  right: 0;\n  padding: ",
        ";\n  background-color: ",
        ";\n  border-top: 1px solid ",
        ";\n  box-shadow: ",
        ";\n\n  &:hover {\n    display: block;\n  }\n\n  @media (max-width: ",
        ") {\n    display: block !important;\n    margin-top: ",
        ";\n    padding: ",
        ";\n    bottom: 0;\n    width: 16.25rem;\n    transform: translateX(100%);\n    transition: transform 0.3s;\n    overflow: auto;\n    border-top: 0;\n    box-shadow: unset;\n\n    &.is-active {\n      transform: translateX(0);\n    }\n  }\n"
    ]);
    TopbarNav_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TopbarNav_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: unset;\n  padding: 0;\n  border: none;\n  display: flex;\n  gap: ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n  }\n"
    ]);
    TopbarNav_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        &:hover {\n          color: ",
        " !important;\n        }\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        &:hover {\n          color: ",
        " !important;\n        }\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  display: flex;\n  ul {\n    display: flex;\n    align-items: center;\n\n    @media (max-width: ",
        ") {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  }\n\n  li {\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    height: ",
        ";\n    display: flex;\n    align-items: center;\n    margin-top: -",
        ";\n    margin-bottom: -",
        ";\n\n    @media (max-width: ",
        ") {\n      padding: 0;\n      margin-bottom: ",
        ";\n      height: unset;\n      display: initial;\n      width: 100%;\n    }\n\n    &:hover > ",
        " {\n      display: block;\n\n      @media (max-width: ",
        ") {\n        display: none;\n      }\n    }\n\n    &.mobileSubnavTrigger {\n      @media (min-width: ",
        ") {\n        display: none;\n      }\n    }\n\n    &.desktopSubnavTrigger {\n      @media (max-width: ",
        ") {\n        display: none;\n      }\n    }\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var StyledTopbarNavItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-f79aa29b-0"
})(TopbarNav_styled_templateObject(), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("current"), (0,theme/* color */.$_)("current"));
var StyledTopbarNavItemIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f79aa29b-1"
})(TopbarNav_styled_templateObject1(), (0,theme/* color */.$_)("link"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledSubnav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f79aa29b-2"
})(TopbarNav_styled_templateObject2(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("white"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* shadow */.AF)("md"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"));
var StyledSubnavClose = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-f79aa29b-3"
})(TopbarNav_styled_templateObject3(), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("link"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledSubnavTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f79aa29b-4"
})(_templateObject4(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledTopbarNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-f79aa29b-5"
})(_templateObject7(), (0,theme/* screen */.sp)("lgMax"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* spacing */.W0)("md"), StyledSubnav, (0,theme/* screen */.sp)("lgMax"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("lgMax"), function(param) {
    var isTalent = param.isTalent;
    return isTalent && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), StyledTopbarNavItem, (0,theme/* color */.$_)("active"));
}, function(param) {
    var isCompanies = param.isCompanies;
    return isCompanies && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), StyledTopbarNavItem, (0,theme/* color */.$_)("active"));
});

;// CONCATENATED MODULE: ./components/layout/topbar/Topbar.styled.tsx

function Topbar_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: ",
        ";\n  display: flex;\n  align-items: center;\n  transition: 0.3s;\n\n  .headroom--unfixed &.is-transparent {\n    background-color: transparent;\n    box-shadow: unset;\n\n    ",
        " {\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n      }\n\n      &:active,\n      &:focus {\n        color: ",
        ";\n      }\n\n      &.active {\n        color: ",
        ";\n      }\n    }\n\n    .brand {\n      display: none;\n    }\n\n    .signin {\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n      }\n\n      &:active,\n      &:focus {\n        color: ",
        ";\n      }\n    }\n\n    .signup {\n      border-color: ",
        ";\n      color: ",
        ";\n      svg {\n        color: ",
        ";\n      }\n\n      &:hover,\n      &:active,\n      &:focus {\n        border-color: ",
        ";\n\n        svg {\n          color: ",
        ";\n        }\n      }\n    }\n\n    .language-trigger {\n      color: ",
        ";\n      &::after {\n        background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6' fill='none'%3E%3Cpath d='M0.538289 0.730988H7.46171C7.94067 0.730988 8.18015 1.30951 7.84111 1.64855L4.38075 5.11161C4.17087 5.32149 3.82913 5.32149 3.61925 5.11161L0.158886 1.64855C-0.180154 1.30951 0.0593268 0.730988 0.538289 0.730988Z' fill='%23dedce4'/%3E%3C/svg%3E\");\n      }\n\n      &:hover,\n      &:active,\n      &:focus {\n        background-color: ",
        ";\n      }\n    }\n  }\n\n  .headroom--scrolled &.is-transparent {\n    .brand--inverse {\n      display: none;\n    }\n  }\n\n  &:not(.is-transparent) {\n    .brand--inverse {\n      display: none;\n    }\n  }\n"
    ]);
    Topbar_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Topbar_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  margin: auto;\n  gap: 1rem;\n"
    ]);
    Topbar_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Topbar_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n"
    ]);
    Topbar_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Topbar_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  border: 0;\n  padding: 0;\n  padding-top: 0.35rem;\n  font-size: ",
        ";\n  color: ",
        ";\n  margin-right: ",
        ";\n  width: ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    Topbar_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Topbar_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    height: 40px;\n    display: block;\n    max-width: 100px;\n\n    @media (min-width: ",
        ") {\n      margin-top: 0;\n      max-width: initial;\n    }\n  }\n"
    ]);
    Topbar_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Topbar_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  padding-left: ",
        ";\n  margin-left: auto;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    Topbar_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Topbar_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  height: 100vh;\n  width: 0;\n  overflow: hidden;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  width: 16.25rem;\n  z-index: ",
        ";\n  transform: translateX(-16.25rem);\n  transition: transform 0.3s;\n\n  /* Forces Safari mobile to not take into account the navbar */\n  @supports (-webkit-touch-callout: none) {\n    height: -webkit-fill-available;\n  }\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n\n  &.is-active {\n    transform: translateX(0);\n  }\n"
    ]);
    Topbar_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Topbar_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"
    ]);
    Topbar_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-top: -5px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: -1;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  font-size: ",
        ";\n  color: ",
        ";\n  margin-right: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: auto;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  margin: ",
        " -",
        " -",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}



var StyledTopbar = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-fc424aeb-0"
})(Topbar_styled_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl4"), StyledTopbarNavItem, (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"), (0,theme/* color */.$_)("active"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_500"), (0,theme/* color */.$_)("midnight_500"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_850"));
var StyledTopbarContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc424aeb-1"
})(Topbar_styled_templateObject1(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"));
var Topbar_styled_StyledTopbarNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc424aeb-2"
})(Topbar_styled_templateObject2());
var StyledTopbarNavTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-fc424aeb-3"
})(Topbar_styled_templateObject3(), (0,theme/* fontSize */.JB)("xl"), (0,theme/* color */.$_)("midnight_300"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lg"));
var StyledTopbarLogo = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-fc424aeb-4"
})(Topbar_styled_templateObject4(), (0,theme/* screen */.sp)("md"));
var StyledTopbarDesktopNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc424aeb-5"
})(Topbar_styled_templateObject5(), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("lgMax"));
var StyledTopbarMobileNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc424aeb-6"
})(Topbar_styled_templateObject6(), (0,theme/* color */.$_)("white"), (0,theme/* shadow */.AF)("md"), (0,theme/* zindex */.Y0)("mobileNav"), (0,theme/* screen */.sp)("lg"));
var StyledTopbarMobileNavContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc424aeb-7"
})(Topbar_styled_templateObject7(), (0,theme/* spacing */.W0)("lg"));
var StyledTopbarMobileNavHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc424aeb-8"
})(_templateObject8(), (0,theme/* spacing */.W0)("lg"), StyledTopbarLogo);
var StyledTopbarNavClose = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-fc424aeb-9"
})(_templateObject9(), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* color */.$_)("midnight_300"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"));
var StyledTopbarMobileBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc424aeb-10"
})(_templateObject10());
var StyledTopbarMobileUserActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc424aeb-11"
})(_templateObject11(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"));

// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var ui_library_dist = __webpack_require__(78197);
// EXTERNAL MODULE: ./utils/config.ts
var config = __webpack_require__(75339);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
;// CONCATENATED MODULE: ./components/layout/topbar/TopbarActions.styled.js

function TopbarActions_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-shrink: 0;\n  flex-grow: 1;\n  align-items: center;\n\n  ",
        ",\n  ",
        " {\n    margin-left: ",
        ";\n\n    @media (max-width: ",
        ") {\n      border: 0;\n      margin-left: ",
        ";\n      padding: ",
        ";\n\n      span {\n        display: none;\n      }\n\n      svg {\n        width: ",
        " !important;\n        height: ",
        ";\n        margin: 0;\n      }\n      \n    }\n\n  }\n\n  .logged-actions {\n    gap: 0.5rem;\n    flex-wrap: nowrap;\n\n\n    a {\n      margin: 0 0.25rem;\n\n      @media (max-width: ",
        ") {\n        padding: 0.5rem;\n      }\n    }\n  }\n\n  .signin {\n    @media (max-width: ",
        ") {\n      display: none;\n    }\n  }\n"
    ]);
    TopbarActions_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TopbarActions_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-left: ",
        ";\n"
    ]);
    TopbarActions_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TopbarActions_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  cursor: pointer;\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n"
    ]);
    TopbarActions_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TopbarActions_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    TopbarActions_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TopbarActions_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  position: absolute;\n  right: 0;\n  top: calc(100% + 20px);\n"
    ]);
    TopbarActions_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TopbarActions_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent; \n  border-radius: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  transition: .2s;\n\n  a {\n    display: flex;\n    color: inherit;\n    transition: .2s;\n    padding: 20px;\n    min-width: 220px;\n    gap: 8px;\n\n    small {\n      color: ",
        ";\n      font-size: ",
        ";\n\n      strong {\n        color: ",
        ";\n        font-weight: ",
        "\n      }\n    }\n\n    &:hover {\n      color: inherit;\n    }\n  }\n\n  svg {\n    flex-shrink: 0;\n    width: ",
        " !important;\n    height: ",
        ";\n    color: ",
        ";\n    transition: .2s;\n    margin-right: ",
        ";\n  }\n\n  &:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n\n    svg {\n      color: ",
        ";\n    }\n  }\n\n  &:active {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    svg {\n      color: currentColor;\n    }\n  }\n\n  &.active {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    svg {\n      color: currentColor;\n    }\n  }\n\n  &.logout,\n  &.logout svg {\n    color: ",
        ";\n\n    &:hover,\n    &:hover svg {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    TopbarActions_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TopbarActions_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        " ",
        ";\n"
    ]);
    TopbarActions_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TopbarActions_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-weight: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    TopbarActions_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function TopbarActions_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  border-top: 1px solid ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  margin-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n"
    ]);
    TopbarActions_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function TopbarActions_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    TopbarActions_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function TopbarActions_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    TopbarActions_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}




var StyledHeaderActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-560885a8-0"
})(TopbarActions_styled_templateObject(), Button_styled/* default */.Z, ButtonLink_styled/* default */.C, (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* screen */.sp)("mdMax"));
var StyledUser = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-560885a8-1"
})(TopbarActions_styled_templateObject1(), (0,theme/* spacing */.W0)("sm"));
var StyledUserTrigger = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-560885a8-2"
})(TopbarActions_styled_templateObject2(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"));
var StyledInitials = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-560885a8-3"
})(TopbarActions_styled_templateObject3(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* radius */.q0)("full"), (0,theme/* color */.$_)("sand_150"), (0,theme/* color */.$_)("sand_500"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledUserOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-560885a8-4"
})(TopbarActions_styled_templateObject4(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xs"), (0,theme/* radius */.q0)("md"), (0,theme/* shadow */.AF)("lg"));
var StyledUserOption = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-560885a8-5"
})(TopbarActions_styled_templateObject5(), (0,theme/* radius */.q0)("md"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("midnight_300"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("text_active"), (0,theme/* fontWeight */.Ue)("regular"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_300"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("midnight_150"), (0,theme/* color */.$_)("text_default"), (0,theme/* color */.$_)("midnight_400"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_400"), (0,theme/* color */.$_)("active"), (0,theme/* color */.$_)("text_over_active"), (0,theme/* color */.$_)("negative_500"), (0,theme/* color */.$_)("navy_800"));
var StyledUserInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-560885a8-6"
})(TopbarActions_styled_templateObject6(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"));
var StyledUserName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-560885a8-7"
})(TopbarActions_styled_templateObject7(), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("sm"));
var StyledActionsNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-560885a8-8"
})(TopbarActions_styled_templateObject8(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"));
var StyledAvailability = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-560885a8-9"
})(TopbarActions_styled_templateObject9(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledUserAvailability = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-560885a8-10"
})(TopbarActions_styled_templateObject10(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xs2"));

// EXTERNAL MODULE: ./components/layout/topbar/TopbarLanguage.tsx
var TopbarLanguage = __webpack_require__(74971);
;// CONCATENATED MODULE: ./components/layout/topbar/TopbarActions.tsx












var TopbarActions = function() {
    var t = (0,useI18n/* useI18n */.Q)("topbar").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,client/* useUser */.aF)(), user = ref.user, isLoading = ref.isLoading;
    if (isLoading) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderActions, {
            children: [
                !user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_library_dist/* Stack */.Kq, {
                    gap: "m",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* ButtonLink */.ZP, {
                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=unete-header"),
                            size: "2xs",
                            schema: "brand2",
                            variant: "hard",
                            label: t("actions.signup"),
                            className: "signup",
                            onClick: function(e) {
                                return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=unete-header"), "unete-header");
                            },
                            startIcon: pro_solid_svg_icons/* faUserAstronaut */.KCX
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Dropdown */.Lt, {
                                label: t("actions.signin"),
                                variant: "ghost",
                                schema: "brand2",
                                size: "xs",
                                position: "right",
                                options: [
                                    {
                                        asLink: true,
                                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.login */.uu.login, locale), "?locale=").concat(locale),
                                        id: 0,
                                        label: "Talento",
                                        icon: pro_solid_svg_icons/* faUserAstronaut */.KCX
                                    },
                                    {
                                        asLink: true,
                                        href: "".concat(config/* config.talentEngineClientUrl */.v.talentEngineClientUrl, "/external-login"),
                                        id: 1,
                                        label: "Empresas",
                                        icon: pro_solid_svg_icons/* faBuilding */.P88
                                    }
                                ]
                            })
                        })
                    ]
                }),
                user && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "logged-actions",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2Dashboard */.uu.portalV2Dashboard, locale),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* ButtonLink */.ZP, {
                                size: "xs",
                                schema: "brand2",
                                variant: "hard",
                                label: t("nav.privateArea"),
                                startIcon: pro_solid_svg_icons/* faUserAstronaut */.KCX
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* Tooltip */.u, {
                            content: t("nav.logout"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.logout */.uu.logout, locale),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_library_dist/* IconLink */.JH, {
                                    href: "#",
                                    size: "xs",
                                    schema: "brand2",
                                    variant: "ghost",
                                    icon: pro_solid_svg_icons/* faSignOut */.HEx,
                                    "aria-label": t("nav.logout")
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarLanguage/* default */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var topbar_TopbarActions = (TopbarActions);

// EXTERNAL MODULE: ./features/job-offers/list/components/JobOffersListComponent.constants.ts
var JobOffersListComponent_constants = __webpack_require__(82324);
// EXTERNAL MODULE: ./utils/job-offers-filter.ts
var job_offers_filter = __webpack_require__(55920);
// EXTERNAL MODULE: ./utils/localize.utils.ts
var localize_utils = __webpack_require__(38062);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/layout/topbar/TopbarTalentSubnav.styled.tsx

function TopbarTalentSubnav_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.3;\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n"
    ]);
    TopbarTalentSubnav_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TopbarTalentSubnav_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.142;\n\n  @media (max-width: ",
        ") {\n    gap: ",
        ";\n  }\n\n  > ",
        " {\n    margin-top: 0;\n  }\n\n  > p {\n    margin: 0;\n    line-height: 1.5;\n    font-size: ",
        ";\n\n    @media (max-width: ",
        ") {\n      font-size: ",
        ";\n      line-height: 1.428;\n    }\n  }\n"
    ]);
    TopbarTalentSubnav_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TopbarTalentSubnav_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n\n  @media (max-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    TopbarTalentSubnav_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TopbarTalentSubnav_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.16666;\n  color: ",
        ";\n\n  @media (max-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    TopbarTalentSubnav_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TopbarTalentSubnav_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  color: inherit;\n\n  @media (max-width: ",
        ") {\n    gap: ",
        ";\n  }\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n    font-size: ",
        ";\n\n    @media (max-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    TopbarTalentSubnav_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TopbarTalentSubnav_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 3.5rem;\n  height: 3.5rem;\n\n  @media (max-width: ",
        ") {\n    width: ",
        ";\n    height: ",
        ";\n  }\n"
    ]);
    TopbarTalentSubnav_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TopbarTalentSubnav_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.428;\n  font-size: ",
        ";\n"
    ]);
    TopbarTalentSubnav_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TopbarTalentSubnav_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(\n      0,\n      1fr\n    );\n  gap: ",
        ";\n  margin: auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  @media (max-width: ",
        ") {\n    grid-template-columns: minmax(0, 1fr);\n    padding: 0;\n  }\n"
    ]);
    TopbarTalentSubnav_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var StyledItemLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-a0695abd-0"
})(TopbarTalentSubnav_styled_templateObject(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("link"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0695abd-1"
})(TopbarTalentSubnav_styled_templateObject1(), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* spacing */.W0)("sm"), StyledItemLink, (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* fontSize */.JB)("sm"));
var StyledGroupTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a0695abd-2"
})(TopbarTalentSubnav_styled_templateObject2(), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* fontSize */.JB)("sm"));
var StyledTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a0695abd-3"
})(TopbarTalentSubnav_styled_templateObject3(), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* color */.$_)("navy_700"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* fontSize */.JB)("md"));
var StyledItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-a0695abd-4"
})(TopbarTalentSubnav_styled_templateObject4(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("link"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* fontSize */.JB)("sm"));
var StyledItemIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-a0695abd-5"
})(TopbarTalentSubnav_styled_templateObject5(), (0,theme/* screen */.sp)("lgMax"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"));
var StyledItemDesc = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a0695abd-6"
})(TopbarTalentSubnav_styled_templateObject6(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("sm"));
var TopbarTalentSubnav_styled_StyledSubnav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0695abd-7"
})(TopbarTalentSubnav_styled_templateObject7(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lgMax"));

;// CONCATENATED MODULE: ./components/layout/topbar/TopbarCompaniesSubnav.tsx









var TopbarCompaniesSubnav = function() {
    var t = (0,useI18n/* useI18n */.Q)("topbar").t;
    var locale = (0,router.useRouter)().locale;
    var nav = [
        {
            title: t("companies_subnav.products.title"),
            navItems: [
                {
                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talentEngineLanding */.uu.talentEngineLanding, locale),
                    title: t("companies_subnav.products.manfred.title"),
                    desc: t("companies_subnav.products.manfred.desc"),
                    icon: (0,paths/* getPublicPath */.A)("/images/companies/nav/manfred.svg")
                },
                {
                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.manfredDailyCompanies */.uu.manfredDailyCompanies, locale),
                    title: t("companies_subnav.products.daily.title"),
                    desc: t("companies_subnav.products.daily.desc"),
                    icon: (0,paths/* getPublicPath */.A)("/images/companies/nav/daily.svg")
                }
            ]
        },
        {
            title: t("companies_subnav.consultancy.title"),
            desc: t("companies_subnav.consultancy.desc"),
            link: t("companies_subnav.consultancy.link"),
            href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.hrAsAService */.uu.hrAsAService, locale)
        },
        {
            title: t("companies_subnav.resources.title"),
            navItems: [
                {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.outOfOffice */.uu.outOfOffice, locale)),
                    title: t("companies_subnav.resources.out-of-office.title"),
                    desc: t("companies_subnav.resources.out-of-office.desc"),
                    icon: (0,paths/* getPublicPath */.A)("/images/icons/writing.svg"),
                    link: t("companies_subnav.resources.out-of-office.link")
                },
                {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.mantechcar24 */.uu.mantechcar24, locale)),
                    title: t("companies_subnav.resources.career-report.title"),
                    desc: t("companies_subnav.resources.career-report.desc"),
                    icon: (0,paths/* getPublicPath */.A)("/images/icons/usage-data.svg")
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopbarTalentSubnav_styled_StyledSubnav, {
        className: "companies",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGroup, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                        children: t("companies_subnav.growth.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("companies_subnav.growth.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.companies */.uu.companies, locale)),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItemLink, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                }),
                                t("companies_subnav.growth.link")
                            ]
                        })
                    })
                ]
            }),
            nav.map(function(group, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGroup, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGroupTitle, {
                            children: group.title
                        }),
                        group.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemDesc, {
                            children: group.desc
                        }),
                        group.link && group.href && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: group.href,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItemLink, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                    }),
                                    group.link
                                ]
                            })
                        }),
                        group.navItems && group.navItems.map(function(navItem, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: navItem.href,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                                    target: navItem.external ? "_blank" : "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemIcon, {
                                            src: navItem.icon,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: navItem.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemDesc, {
                                                    children: navItem.desc
                                                }),
                                                navItem.link && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItemLink, {
                                                    as: "span",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                                        }),
                                                        navItem.link
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var topbar_TopbarCompaniesSubnav = (TopbarCompaniesSubnav);

;// CONCATENATED MODULE: ./components/layout/topbar/TopbarTalentSubnav.tsx









var TopbarTalentSubnav = function() {
    var t = (0,useI18n/* useI18n */.Q)("topbar").t;
    var locale = (0,router.useRouter)().locale;
    var nav = [
        {
            title: t("talent_subnav.profile.title"),
            navItems: [
                {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talent */.uu.talent, locale), "#professional_profile"),
                    title: t("talent_subnav.profile.profile.title"),
                    desc: t("talent_subnav.profile.profile.desc"),
                    icon: (0,paths/* getPublicPath */.A)("/images/icons/icon_default_softskill.svg")
                },
                {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/github-synchronization"),
                    title: t("talent_subnav.profile.synch.title"),
                    desc: t("talent_subnav.profile.synch.desc"),
                    icon: (0,paths/* getPublicPath */.A)("/images/icons/update.svg")
                }
            ]
        },
        {
            title: t("talent_subnav.search.title"),
            navItems: [
                {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.jobOffers */.uu.jobOffers, locale)),
                    title: t("talent_subnav.search.offers.title"),
                    desc: t("talent_subnav.search.offers.desc"),
                    icon: (0,paths/* getPublicPath */.A)("/images/icons/consent.svg")
                },
                {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.manfredDaily */.uu.manfredDaily, locale)),
                    title: t("talent_subnav.search.teams.title"),
                    desc: t("talent_subnav.search.teams.desc"),
                    icon: (0,paths/* getPublicPath */.A)("/images/icons/roles/software-engineering-left.svg")
                },
                {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.cvApplicationsLanding */.uu.cvApplicationsLanding, locale)),
                    title: t("talent_subnav.search.tracker.title"),
                    desc: t("talent_subnav.search.tracker.desc"),
                    icon: (0,paths/* getPublicPath */.A)("/images/icons/intercultural.svg")
                }
            ]
        },
        {
            title: t("talent_subnav.growth.title"),
            navItems: [
                {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.salaryCompass */.uu.salaryCompass, locale)),
                    title: t("talent_subnav.growth.benchmark.title"),
                    desc: t("talent_subnav.growth.benchmark.desc"),
                    icon: (0,paths/* getPublicPath */.A)("/images/icons/usage-data.svg")
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopbarTalentSubnav_styled_StyledSubnav, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGroup, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                        children: t("talent_subnav.ally.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("talent_subnav.ally.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talent */.uu.talent, locale)),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItemLink, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                }),
                                t("talent_subnav.ally.link")
                            ]
                        })
                    })
                ]
            }),
            nav.map(function(group, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGroup, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGroupTitle, {
                            children: group.title
                        }),
                        group.navItems.map(function(navItem, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: navItem.href,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemIcon, {
                                            src: navItem.icon,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: navItem.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemDesc, {
                                                    children: navItem.desc
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var topbar_TopbarTalentSubnav = (TopbarTalentSubnav);

;// CONCATENATED MODULE: ./components/layout/topbar/TopbarNav.tsx














var TopbarNav = function() {
    var t = (0,useI18n/* useI18n */.Q)("topbar").t;
    var ref = (0,router.useRouter)(), pathname = ref.pathname, locale = ref.locale;
    var getNavItemClassname = function(path) {
        return pathname.startsWith(path) ? "active" : "";
    };
    var isTalent = pathname.startsWith("/talent");
    var isCompanies = pathname.startsWith("/empresas") || pathname.startsWith("/companies");
    var ref1 = (0,react.useState)(false), talentSubNavActive = ref1[0], setTalentSubnavActive = ref1[1];
    var ref2 = (0,react.useState)(false), companiesSubNavActive = ref2[0], setTCompaniesSubnavActive = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarNav, {
        "aria-label": t("nav.label"),
        isTalent: isTalent,
        isCompanies: isCompanies,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.jobOffers */.uu.jobOffers, locale), "?").concat((0,job_offers_filter/* getUrlParamsFromJobOffersFilter */.Ci)(JobOffersListComponent_constants/* DEFAULT_FILTER */.XW, (0,localize_utils/* getLocale */.K)(locale))),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarNavItem, {
                            className: getNavItemClassname("/job-offers"),
                            children: t("nav.offers")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "desktopSubnavTrigger",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.companies */.uu.companies, locale)),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarNavItem, {
                                className: getNavItemClassname("/companies"),
                                children: t("nav.companies")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubnav, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(topbar_TopbarCompaniesSubnav, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "desktopSubnavTrigger",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.talent */.uu.talent, locale)),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarNavItem, {
                                className: getNavItemClassname("/talent"),
                                children: t("nav.talent")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubnav, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(topbar_TopbarTalentSubnav, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "mobileSubnavTrigger",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarNavItem, {
                            as: "button",
                            className: getNavItemClassname("/talent"),
                            onClick: function() {
                                return setTalentSubnavActive(true);
                            },
                            children: [
                                t("nav.talent"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarNavItemIcon, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faArrowRight */.eFW
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubnav, {
                            className: talentSubNavActive ? "is-active" : "",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubnavClose, {
                                    onClick: function() {
                                        return setTalentSubnavActive(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_light_svg_icons/* faArrowLeft */.acZ
                                        }),
                                        t("talent_subnav.back")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubnavTitle, {
                                    children: t("nav.talent")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(topbar_TopbarTalentSubnav, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "mobileSubnavTrigger",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarNavItem, {
                            as: "button",
                            className: getNavItemClassname("/talent"),
                            onClick: function() {
                                return setTCompaniesSubnavActive(true);
                            },
                            children: [
                                t("nav.companies"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarNavItemIcon, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faArrowRight */.eFW
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubnav, {
                            className: companiesSubNavActive ? "is-active" : "",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubnavClose, {
                                    onClick: function() {
                                        return setTCompaniesSubnavActive(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_light_svg_icons/* faArrowLeft */.acZ
                                        }),
                                        t("talent_subnav.back")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubnavTitle, {
                                    children: t("nav.companies")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(topbar_TopbarCompaniesSubnav, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.team */.uu.team, locale)),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarNavItem, {
                            className: getNavItemClassname("/team"),
                            children: t("nav.us")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale)),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarNavItem, {
                            className: getNavItemClassname("/blog"),
                            children: t("nav.blog")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.contact */.uu.contact, locale)),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarNavItem, {
                            className: getNavItemClassname("/contact"),
                            children: t("nav.contact")
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var topbar_TopbarNav = (TopbarNav);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(97143);
;// CONCATENATED MODULE: ./components/layout/topbar/TopbarSocial.styled.js

function TopbarSocial_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n"
    ]);
    TopbarSocial_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TopbarSocial_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-size: ",
        ";\n  line-height: 1;\n  text-transform: uppercase;\n  margin-bottom: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    TopbarSocial_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TopbarSocial_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n"
    ]);
    TopbarSocial_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TopbarSocial_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin-right: ",
        ";\n\n  svg {\n    display: block;\n    width: 1em !important;\n  }\n"
    ]);
    TopbarSocial_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledTopbarSocial = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e728c5b8-0"
})(TopbarSocial_styled_templateObject());
var StyledTopbarSocialTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e728c5b8-1"
})(TopbarSocial_styled_templateObject1(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledTopbarSocialNav = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-e728c5b8-2"
})(TopbarSocial_styled_templateObject2());
var StyledTopbarSocialNavItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-e728c5b8-3"
})(TopbarSocial_styled_templateObject3(), (0,theme/* fontSize */.JB)("xl"), (0,theme/* spacing */.W0)("lg"));

;// CONCATENATED MODULE: ./components/layout/topbar/TopbarSocial.tsx





var TopbarSocial = function() {
    var t = (0,useI18n/* useI18n */.Q)("topbar").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarSocial, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarSocialTitle, {
                children: t("nav.socialMediaTitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarSocialNav, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarSocialNavItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://t.me/getmanfred",
                            title: "Telegram",
                            target: "_blank",
                            rel: "noreferrer noopener",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                "aria-hidden": "true",
                                icon: free_brands_svg_icons/* faTelegramPlane */.IKq
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarSocialNavItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://es.linkedin.com/company/manfred",
                            title: "Linkedin",
                            target: "_blank",
                            rel: "noreferrer noopener",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                "aria-hidden": "true",
                                icon: free_brands_svg_icons/* faLinkedin */.D9H
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarSocialNavItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://twitter.com/getmanfred",
                            title: "Twitter",
                            target: "_blank",
                            rel: "noreferrer noopener",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                "aria-hidden": "true",
                                icon: free_brands_svg_icons/* faTwitter */.mdU
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var topbar_TopbarSocial = (TopbarSocial);

;// CONCATENATED MODULE: ./components/layout/topbar/Topbar.tsx


















var Topbar = function(param) {
    var topBarTransparent = param.topBarTransparent, isHeadroomPinned = param.isHeadroomPinned, isHeadroomUnpinned = param.isHeadroomUnpinned;
    var toggleNav = function toggleNav() {
        setActiveState(setActive === "" ? "is-active" : "");
    };
    var t = (0,useI18n/* useI18n */.Q)("topbar").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)(""), setActive = ref[0], setActiveState = ref[1];
    var user = (0,client/* useUser */.aF)().user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                downTolerance: 5,
                upTolerance: 5,
                onPin: isHeadroomPinned,
                onUnpin: isHeadroomUnpinned,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbar, {
                    className: "".concat(topBarTransparent ? "is-transparent" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Topbar_styled_StyledTopbarNav, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarNavTrigger, {
                                        onClick: toggleNav,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_light_svg_icons/* faBars */.xiG
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.home */.uu.home, locale),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarLogo, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: logos/* LOGO_MANFRED */.$q,
                                                    alt: "Manfred logo",
                                                    className: "brand"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: logos/* LOGO_MANFRED_WHITE */.YM,
                                                    alt: "Manfred logo",
                                                    className: "brand--inverse"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarDesktopNav, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(topbar_TopbarNav, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(topbar_TopbarActions, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarMobileNav, {
                className: "".concat(setActive),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarMobileNavContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarMobileNavHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.home */.uu.home, locale),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarLogo, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: logos/* LOGO_MANFRED */.$q,
                                            alt: "Manfred logo"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarNavClose, {
                                    onClick: toggleNav,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faTimes */.NBC
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(topbar_TopbarNav, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarMobileBottom, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(topbar_TopbarSocial, {}),
                                !user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarMobileUserActions, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.login */.uu.login, locale), "?locale=").concat(locale),
                                            sizes: "sm",
                                            isLink: true,
                                            "aria-label": t("actions.signin"),
                                            className: "signin",
                                            children: t("actions.signin")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=unete-header"),
                                            sizes: "sm",
                                            variant: "secondary",
                                            "aria-label": t("actions.signup"),
                                            className: "signup",
                                            onClick: function(e) {
                                                return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=unete-header"), "unete-header");
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faSignInAlt */.$Wj
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    children: t("actions.signup")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var topbar_Topbar = (Topbar);

;// CONCATENATED MODULE: ./components/layout/Page.tsx











var HEADER_HEIGHT = 64;
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6582), __webpack_require__.e(995)]).then(__webpack_require__.bind(__webpack_require__, 70995));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70995)
            ];
        }
    },
    ssr: false
});
var PageNav = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1489).then(__webpack_require__.bind(__webpack_require__, 79161));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79161)
            ];
        }
    },
    ssr: false
});
var ScrollTop = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9436).then(__webpack_require__.bind(__webpack_require__, 89436));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89436)
            ];
        }
    },
    ssr: false
});
var MarkdownComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6129), __webpack_require__.e(7792)]).then(__webpack_require__.bind(__webpack_require__, 57792));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57792)
            ];
        }
    },
    ssr: false
});
var Page = function(param) {
    var children = param.children, offerFooter = param.offerFooter, sections = param.sections, className = param.className, pageVariant = param.pageVariant, _filters = param.filters, filters = _filters === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : _filters, hasScrollTop = param.hasScrollTop, topBarTransparent = param.topBarTransparent, noTopBar = param.noTopBar, noFooter = param.noFooter, onDrawerClose = param.onDrawerClose, customFooter = param.customFooter, bannerText = param.bannerText;
    var headroomPinned = function headroomPinned() {
        setIsHeadroomPinned(true);
        document.documentElement.style.setProperty("--header-offset", "".concat(HEADER_HEIGHT, "px"));
    };
    var headroomUnpinned = function headroomUnpinned() {
        setIsHeadroomPinned(false);
        document.documentElement.style.setProperty("--header-offset", "0px");
    };
    var t = (0,useI18n/* useI18n */.Q)("common").t;
    var ref = (0,react.useState)(false), isHeadroomPinned = ref[0], setIsHeadroomPinned = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageDrawerContext/* PageDrawerContextProvider */.jc, {
        onDrawerClose: onDrawerClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page_styled/* StyledPage */.F, {
            variant: pageVariant,
            className: "".concat(isHeadroomPinned ? "is-headroom-pinned" : ""),
            children: [
                !!bannerText && /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_LandingNotification, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent, {
                        content: bannerText
                    })
                }),
                !noTopBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(topbar_Topbar, {
                    topBarTransparent: topBarTransparent,
                    isHeadroomPinned: headroomPinned,
                    isHeadroomUnpinned: headroomUnpinned
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: className,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(modules/* Element */.W_, {
                        id: "pageTop",
                        name: "pageTop",
                        children: [
                            sections && sections.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNav, {
                                sections: sections,
                                prevLabel: t("pageNav.prev"),
                                nextLabel: t("pageNav.next"),
                                navLabel: t("pageNav.label")
                            }),
                            children
                        ]
                    })
                }),
                filters,
                offerFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                    offerFooter: offerFooter,
                    hasScrollTop: hasScrollTop
                }),
                customFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: customFooter
                }),
                !customFooter && !offerFooter && !noFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                hasScrollTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTop, {})
            ]
        })
    });
};
/* harmony default export */ var layout_Page = (Page);


/***/ }),

/***/ 21058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ StyledLanguage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Button_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59760);
/* harmony import */ var components_shared_Dropdown_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23211);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  ",
        " {\n    margin-left: ",
        ";\n    min-height: 2.75rem;\n\n    @media (max-width: ",
        ") {\n      margin-left: ",
        ";\n    }\n  }\n\n  ",
        " {\n    top: calc(100% + 14px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledLanguage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5f06f6a5-0"
})(_templateObject(), components_shared_Button_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_theme__WEBPACK_IMPORTED_MODULE_3__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_3__/* .screen */ .sp)("mdMax"), (0,_theme__WEBPACK_IMPORTED_MODULE_3__/* .spacing */ .W0)("xs2"), components_shared_Dropdown_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledDropdown */ .EI);


/***/ }),

/***/ 74971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_shared_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15659);
/* harmony import */ var components_shared_Dropdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25728);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23357);
/* harmony import */ var context_slugs_slugs_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18694);
/* harmony import */ var hooks_api_manfredite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33219);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93642);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2784);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21428);
/* harmony import */ var services_service_event_tracking__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27862);
/* harmony import */ var services_ui_cookies_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24637);
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62177);
/* harmony import */ var _TopbarLanguage_styled__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21058);

















var TopbarLanguage = function() {
    var ref = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)(), locale = ref.locale, asPath = ref.asPath;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useContext)(context_slugs_slugs_context__WEBPACK_IMPORTED_MODULE_4__/* .SlugsContext */ .X), slug = ref1.slug, hasSlugForLang = ref1.hasSlugForLang;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_3__/* .LoggedUserContext */ .Vi), user = ref2.user, refreshUserData = ref2.refreshUserData;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), languageMenuOpen = ref3[0], setLanguageMenuOpen = ref3[1];
    var node = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var manfredite = (0,hooks_api_manfredite__WEBPACK_IMPORTED_MODULE_5__/* .useManfredite */ .CV)().manfredite;
    var updateManfrediteFromModel = (0,hooks_api_manfredite__WEBPACK_IMPORTED_MODULE_5__/* .useManfrediteUpdate */ .OB)().updateManfrediteFromModel;
    var handleCloseLanugageMenuClick = function(e) {
        var ref;
        if ((ref = node.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) {
            return;
        }
        setLanguageMenuOpen(false);
    };
    var handleLangChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(newLang) {
            var ex, targetPath;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        services_ui_cookies_service__WEBPACK_IMPORTED_MODULE_9__/* ["default"].add */ .Z.add(services_ui_cookies_service__WEBPACK_IMPORTED_MODULE_9__/* .COOKIES_NEXT_LOCALE */ .W, newLang);
                        // Event tracking with user trait
                        services_service_event_tracking__WEBPACK_IMPORTED_MODULE_8__/* ["default"].track */ .Z.track({
                            type: "Settings - Interface Language Changed",
                            properties: {
                                title: document === null || document === void 0 ? void 0 : document.title,
                                fromPreferredLanguage: locale === null || locale === void 0 ? void 0 : locale.toLowerCase(),
                                toPreferredLanguage: newLang === null || newLang === void 0 ? void 0 : newLang.toLowerCase()
                            }
                        }, {
                            preferredLanguage: newLang === null || newLang === void 0 ? void 0 : newLang.toLowerCase()
                        });
                        if (!(user && manfredite)) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            updateManfrediteFromModel(manfredite, {
                                preferredLanguage: newLang.toUpperCase()
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        ex = _state.sent();
                        console.warn("Could not update Manfredite preferred language. Exception: ".concat(ex));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        refreshUserData({
                            preferredLanguage: newLang
                        });
                        // If user is logged in, identify user in tracking system to update the preferredLanguage trait
                        services_service_event_tracking__WEBPACK_IMPORTED_MODULE_8__/* ["default"].identifyUser */ .Z.identifyUser((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, user), {
                            preferredLanguage: newLang === null || newLang === void 0 ? void 0 : newLang.toLowerCase()
                        }));
                        _state.label = 5;
                    case 5:
                        targetPath = "/".concat(newLang).concat(asPath);
                        if (asPath.startsWith("/blog/page")) {
                            targetPath = "/".concat(newLang, "/blog");
                            window.location.href = "".concat(window.location.origin).concat(targetPath);
                            return [
                                2
                            ];
                        }
                        if (slug && asPath.startsWith("/blog/category")) {
                            if (!hasSlugForLang(newLang)) {
                                targetPath = "/".concat(newLang, "/blog");
                                window.location.href = "".concat(window.location.origin).concat(targetPath);
                                return [
                                    2
                                ];
                            }
                            targetPath = "/".concat(newLang, "/blog/category/").concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_16__/* .getTranslatedText */ .G)(slug, newLang));
                            window.location.href = "".concat(window.location.origin).concat(targetPath);
                            return [
                                2
                            ];
                        }
                        if (slug && asPath.startsWith("/blog") && hasSlugForLang(newLang)) {
                            targetPath = "/".concat(newLang, "/blog/").concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_16__/* .getTranslatedText */ .G)(slug, newLang));
                            window.location.href = "".concat(window.location.origin).concat(targetPath);
                            return [
                                2
                            ];
                        }
                        window.location.href = "".concat(window.location.origin).concat(targetPath);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLangChange(newLang) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        document.addEventListener("mousedown", handleCloseLanugageMenuClick);
        return function() {
            document.removeEventListener("mousedown", handleCloseLanugageMenuClick);
        };
    }, []);
    var languages = [
        {
            label: "English",
            value: "en",
            href: (0,utils_app_urls__WEBPACK_IMPORTED_MODULE_10__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_10__/* .APP_URLS.home */ .uu.home, "en"),
            activeClassCondition: locale === "en"
        },
        {
            label: "Espa\xf1ol",
            value: "es",
            href: (0,utils_app_urls__WEBPACK_IMPORTED_MODULE_10__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_10__/* .APP_URLS.blog */ .uu.blog, "es"),
            activeClassCondition: locale === "es"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_TopbarLanguage_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledLanguage */ .j, {
        ref: node,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Button__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .z, {
                variant: "tertiary",
                sizes: "sm",
                isTrigger: true,
                onClick: function() {
                    return setLanguageMenuOpen(!languageMenuOpen);
                },
                "aria-haspopup": "listbox",
                "aria-controls": "language-dropdown",
                "aria-label": "Selected Language: EN",
                "aria-expanded": languageMenuOpen ? "true" : "false",
                className: "language-trigger",
                children: locale === null || locale === void 0 ? void 0 : locale.toUpperCase()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Dropdown__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: "language-dropdown",
                options: languages,
                style: {
                    display: languageMenuOpen ? "block" : "none"
                },
                onOptionSelect: handleLangChange
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopbarLanguage);


/***/ }),

/***/ 68692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _ButtonLink_styled__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _ButtonLink_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8536);



/***/ })

}]);